import { useState } from "react";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { concatClassnames } from "shared/utils/concatClassnames";
import SampleImage from "./components/sample-image";
import SampleImageFooter from "./components/sample-image-footer";
import SamplesConfigurator from "./components/samples-configurator";

interface SamplesProps {
  id?: string;
  className?: string;
}
const Samples = ({ id = "", className = "" }: SamplesProps) => {
  const [selectedSample, setSelectedSample] =
    useState<CategoryStandardProduct>();

  return (
    <section
      id={id}
      className={concatClassnames(
        "gg-grid gg-w-full gg-grid-cols-12 gg-bg-white gg-shadow-main lg:gg-gap-x-8 lg:gg-px-8 lg:gg-py-9",
        className,
      )}
    >
      <div className="gg-relative gg-col-span-12 gg-flex gg-h-full gg-flex-col lg:gg-col-span-6">
        <SampleImage
          className="gg-top-0 gg-h-full gg-w-full lg:gg-absolute"
          selectedSample={selectedSample}
        />
        <SampleImageFooter
          isVisible={selectedSample !== undefined}
          className="gg-border lg:gg-mt-auto lg:gg-border-none"
        />
      </div>
      <SamplesConfigurator
        selectedSample={selectedSample}
        setSelectedSample={setSelectedSample}
        className="gg-col-span-12 lg:gg-col-span-6"
      />
    </section>
  );
};
export default Samples;
